import { useGetInsuranceReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function InsuranceReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      usePivotQuery={useGetInsuranceReport}
      title={t('common:insurance-report')}
      completeName={['customer', 'admin', 'guest', 'status']}
    />
  );
}
